import EFPic from '@/components/UI/EFPic';
import { useGlobal } from '@/utils/useGlobal';
import { TweenMax } from 'gsap';
import css from './index.module.scss';

export default function C() {
    const { useLang, useEffect, Link, useState } = useGlobal();
    const { t } = useLang('csr');
    const data = [
        {
            img: ['/img/csr/h5/3_1.webp', '/img/csr/h5/3_1.jpg'],
            desc: t('secC_list1_desc'),
            link: 'https://blog.ecoflow.com/jp/emergency-supplies/',
        },
        {
            img: ['/img/csr/h5/3_2.webp', '/img/csr/h5/3_2.jpg'],
            desc: t('secC_list2_desc'),
            link: 'https://blog.ecoflow.com/jp/teidentaisaku/',
        },
        {
            img: ['/img/csr/h5/3_3.webp', '/img/csr/h5/3_3.jpg'],
            desc: t('secC_list3_desc'),
            link: 'https://blog.ecoflow.com/jp/disaster/',
        },
        {
            img: ['/img/csr/h5/3_4.webp', '/img/csr/h5/3_4.jpg'],
            desc: t('secC_list4_desc'),
            link: 'https://blog.ecoflow.com/jp/portable-power-station-disaster-prevention/',
        },
        {
            img: ['/img/csr/h5/3_5.webp', '/img/csr/h5/3_5.jpg'],
            desc: t('secC_list5_desc'),
            link: 'https://blog.ecoflow.com/jp/camp-items-disaster-prevention/',
        },
    ];

    const [active, setActive] = useState(0)
    // 触屏拖拽mobile
    let startX = 0, flag = false;
    const touchStart = (e: any) => {
        startX = e.targetTouches[0].clientX;
        flag = true;
    };
    const touchMove = (e: any) => {
        const moveX = e.targetTouches[0].clientX;
        if(flag){
            if(moveX < startX && active < data?.length - 1){
                e.currentTarget.style.transition = '0.4s left cubic-bezier(0.20, 0.00, 0.32, 1.00)';
                e.currentTarget.style.left = -(1 + active) * 3 + (active === data?.length - 2 ? 0.35 : 0) + 'rem'; // 3 => 2.8width + 0.2gap， 最后一个单独计算
                setActive(active + 1);
                flag = false;
            }
            if(moveX > startX && active > 0){
                e.currentTarget.style.transition = '0.4s left cubic-bezier(0.20, 0.00, 0.32, 1.00)';
                e.currentTarget.style.left = -(active - 1) * 3 + (active === data?.length - 1 ? 0.35 : 0) + 'rem';
                setActive(active - 1);
                flag = false;
            }
        }
    };

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        // // 竖线渐变（高度+透明度）
        // new ScrollMagic.Scene({
        //     triggerElement: '.csr_h5_C .guideBox',
        //     triggerHook: 1,
        //     offset: 80,
        //     duration: 150,
        // })
        //     .setTween(TweenMax.to('.csr_h5_C .line', 0.5, { opacity: 1, height: '0.36rem' }))
        //     .addTo(controller);

        // 竖线右侧文字渐入（left位移）以及title文字淡入上滑
        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_C .guideBox',
            triggerHook: 1,
            offset: 200,
            // duration: 150,
        })
            .setClassToggle('.csr_h5_C .innerBox', 'enter')
            .addTo(controller);

        // // 文本内容CSS动画
        // new ScrollMagic.Scene({
        //     triggerElement: '.csr_h5_C .textBox',
        //     triggerHook: 1,
        //     offset: 100,
        //     // duration: 200,
        // })
        //     .setClassToggle('.csr_h5_C .textBox', 'enter')
        //     .addTo(controller);

        // // Swiper内容CSS动画
        // new ScrollMagic.Scene({
        //     triggerElement: '.csr_h5_C .swiper_c',
        //     triggerHook: 1,
        //     offset: 240,
        //     // duration: 200,
        // })
        //     .setClassToggle('.csr_h5_C .swiper_c', 'enter')
        //     .addTo(controller);
    }, []);

    const letters: [string] = t('secC_title').split('');

    return (
        <div className={`csr_h5_C ${css.csr_h5_C}`}>
            <div className="innerBox">
                <div className="guideBox">
                    <div className="line"></div>
                    <div className="guide">{t('secC_guide')}</div>
                </div>
                <div className="titleBox">
                    <div className="title">
                        {letters?.map((letter: string, k: number) => (
                            <span className={`letter_c letter_${k}`} key={k}>{letter}</span>
                        ))}
                    </div>
                </div>
                <div className="textBox">
                    <div className="text">{t('secC_text')}</div>
                </div>
                <div className="swiper_c">
                    <ul className="swiperLists" onTouchMove={touchMove} onTouchStart={touchStart}>
                        {data?.map((list: any, k: number) => (
                            <Link className="swiperList" key={k} href={list?.link || '/'} target="_blank">
                                <div className="imgBox">
                                    <div className="img">
                                        <EFPic src={list?.img} alt={list?.desc} aria-label={list?.desc} />
                                    </div>
                                </div>
                                <p className="desc">{list?.desc}</p>
                            </Link>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
